import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { VeracodeConnector } from '../../connector';

export const VeracodeService = IntegrationService.make({
  connector: VeracodeConnector,
  name: Integration_Service_Names_Enum.Veracode,
});
